import { useState, useEffect } from 'react';
import Header from '@/components/shared/Header';
import Footer from '@/components/shared/Footer';
import PageBanner from '@/components/shared/PageBanner';
import ServiceCard from '@/components/shared/ServiceCard';
import PricingCard from '@/components/shared/PricingCard';
import { publicApi } from '@/lib/api';

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, pricingRes] = await Promise.all([
          publicApi.getServices(),
          publicApi.getPricing()
        ]);
        setServices(servicesRes.data);
        setPricing(pricingRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const mainServices = services.filter(s => s.service_type === 'main');

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        <PageBanner 
          title="Services" 
          breadcrumbs={[{ label: 'Services' }]} 
        />

        {/* Services Grid */}
        <section className="py-20" data-testid="services-section">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-3 gap-8">
              {mainServices.map((service) => (
                <ServiceCard key={service.id} service={service} variant="image" />
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="py-20 bg-muted/30" data-testid="pricing-section">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">Our Pricing</h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Choose the plan that fits your career development needs
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8 items-stretch">
              {pricing.map((plan) => (
                <PricingCard key={plan.id} plan={plan} />
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ServicesPage;
